import { DateHelper } from '@/helper';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { HomeCard } from './homeCard';
import { TRACK_EVENTS } from '@/providers/eventAnalytics/trackEvents';
import { eventAnalytics } from '@/providers';

export function DocumentCard({
  document,
}: {
  document: { id: number | string; documentName: string; createdAt: string };
}) {
  const navigate = useNavigate();
  const date = DateHelper.formatDateToDisplay(DateTime.fromISO(document.createdAt));

  return (
    <HomeCard
      category='Documents'
      title={document.documentName}
      descriptions={[date]}
      buttons={[
        {
          label: 'View details',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Documents',
              buttonClicked: 'View details',
              documentId: document.id,
            });
            return navigate(`/documents/${document.id}`);
          },
          variant: 'primary',
        },
        {
          label: 'View all',
          onClick: () => {
            eventAnalytics.track(TRACK_EVENTS.HOME_PAGE_CARD_CLICKED, {
              cardName: 'Documents',
              buttonClicked: 'View all',
            });
            return navigate('/documents');
          },
        },
      ]}
    />
  );
}
